import { useAccountSwitcherContext } from '../components/AccountSwitcherProvider';

/**
 * Hook to access current user
 * Returns the currently authenticated user or null
 */
export function useUser() {
  const { session } = useAccountSwitcherContext();

  return session.currentUser;
}
